"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GroupAccountsActions_1 = __importDefault(require("../actions/GroupAccountsActions"));
const ajax_1 = __importDefault(require("../endpoints/ajax"));
// export interface GroupAccountsSourceInterface extends Source<GroupAccountsSourceMethods, any> {
//     fetchAccounts: () => SourceData<Account.ConstructorOptions[]>,
//     fetchMonthsForAccount: () => SourceData<Month.ConstructorOptions[]>,
//     fetchAccountNumberTagsForAccount: () => SourceData<AccountNumberTag.ConstructorOptions[]>,
// }
//
// function tester(arg: StoreMethodsSource<any, GroupAccountsSourceMethods>) {
//     const method = arg.fetchMonthsForAccount().remote({}, 'test').then(it => it.)
//
// }
const GroupAccountsSource = {
    fetchAccounts() {
        return {
            remote(state) {
                return ajax_1.default.getLinkedAccounts();
            },
            local() {
                return null;
            },
            success: GroupAccountsActions_1.default.receivedAccounts,
            loading: GroupAccountsActions_1.default.loadingAccounts,
            error: GroupAccountsActions_1.default.fetchingAccountsFailed,
        };
    },
    fetchMonthsForAccount() {
        return {
            remote(state, accountId) {
                return ajax_1.default.getLinkedAccountsMonths(accountId)
                    .then(months => ({
                    accountId,
                    months,
                }));
            },
            local() {
                return null;
            },
            success: GroupAccountsActions_1.default.receivedMonths,
            loading: GroupAccountsActions_1.default.loadingMonths,
            error: GroupAccountsActions_1.default.fetchingMonthsFailed,
        };
    },
    fetchAccountNumberTagsForAccount() {
        return {
            remote(state, accountId) {
                return ajax_1.default.getLinkedAccountsAccountNumberTags(accountId)
                    .then(accountNumberTags => ({
                    accountId,
                    accountNumberTags,
                }));
            },
            local() {
                return null;
            },
            success: GroupAccountsActions_1.default.receivedAccountNumberTags,
            loading: GroupAccountsActions_1.default.loadingAccountNumberTags,
            error: GroupAccountsActions_1.default.fetchingAccountNumberTagsFailed,
        };
    },
};
exports.default = GroupAccountsSource;
